import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 w-full z-50" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "hidden md:flex md:flex-grow justify-center items-center md:space-x-8 lg:space-x-20 font-roboto" }
const _hoisted_4 = { class: "flex justify-end flex-grow items-center" }
const _hoisted_5 = { class: "hidden md:flex active:scale-90" }
const _hoisted_6 = { class: "md:hidden relative" }
const _hoisted_7 = {
  key: 0,
  class: "fixed top-6 right-0 z-50 flex flex-col bg-gray-800 text-white w-44 max-h-screen overflow-y-auto"
}
const _hoisted_8 = { class: "flex justify-end pr-3" }
const _hoisted_9 = { class: "space-y-4 mt-8 ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_on = _resolveComponent("button-on")!
  const _component_tool_bar = _resolveComponent("tool-bar")!
  const _component_about_dialog = _resolveComponent("about-dialog")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_tool_bar, { class: "bg-gray-800 text-white sm:flex md:grid md:grid-cols-[1.5fr,2fr,1fr] lg:grid-cols-[1fr,2fr,1fr] items-center justify-between p-4 shadow-lg rounded-none" }, {
      start: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('/'))),
            class: "ml-3 md:ml-5 text-2xl font-bold cursor-pointer md:text-3xl font-roboto",
            title: "Logo ViBi Flix",
            alt: "Logo ViBi Flix"
          }, " ViBi Flix ")
        ])
      ]),
      center: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainRoutes, (route) => {
            return (_openBlock(), _createBlock(_component_button_on, {
              key: route.path,
              class: _normalizeClass([{ 'font-bold border-b-2 border-gray-200': _ctx.isActive(route.path) }, "p-2 text-sm transition duration-300 transform hover:-translate-y-1 hover:bg-gray-700 active:scale-90"]),
              title: route.label,
              label: route.label,
              icon: route.icon,
              onClick: ($event: any) => (_ctx.navigateTo(route.path))
            }, null, 8, ["class", "title", "label", "icon", "onClick"]))
          }), 128))
        ])
      ]),
      end: _withCtx(() => [
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_button_on, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAboutVisible = true)),
              icon: "pi pi-info-circle",
              class: "p-2 mr-4 text-sm transition duration-300 transform hover:-translate-y-1 hover:bg-gray-700",
              title: "Sobre",
              severity: "warn"
            })
          ]),
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_button_on, {
              onClick: _ctx.toggleSideBar,
              class: "focus:outline-none"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass([['pi', _ctx.isSidebarVisible ? 'pi-times' : 'pi-bars'], "text-lg"])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.isSidebarVisible)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSideBar && _ctx.toggleSideBar(...args))),
              class: "focus:outline-none"
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "pi pi-times" }, null, -1)
            ]))
          ]),
          _createElementVNode("section", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainRoutes, (route) => {
              return (_openBlock(), _createBlock(_component_button_on, {
                key: route.path,
                class: _normalizeClass([{ 'font-bold': _ctx.isActive(route.path) }, "p-2 text-sm transition duration-300 transform hover:bg-gray-700 cursor-pointer flex items-center space-x-2 active:scale-90 font-roboto"]),
                title: route.label,
                label: route.label,
                icon: route.icon,
                onClick: ($event: any) => (_ctx.navigateTo(route.path))
              }, null, 8, ["class", "title", "label", "icon", "onClick"]))
            }), 128)),
            _createElementVNode("span", null, [
              _createVNode(_component_button_on, {
                label: "Sobre",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isAboutVisible = true, _ctx.isSidebarVisible = false)),
                icon: "pi pi-info-circle",
                title: "Sobre",
                class: "my-4 p-2 text-sm transition duration-300 transform hover:bg-gray-700 cursor-pointer flex items-center space-x-2 active:scale-90 font-roboto",
                severity: "warn"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_about_dialog, {
      visible: _ctx.isAboutVisible,
      onCancelDialog: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAboutVisible = false))
    }, null, 8, ["visible"])
  ]))
}